import {getSocialNetworks, showSocialNetwork} from "@/api/social_network";

const state = {
    socialNetworkLoaded: false,
    socialNetwork: {},
    socialNetworks: [],
};

const getters = {
    socialNetworks: state => {
        return state.socialNetworks;
    },

    socialNetwork: state => {
        return state.socialNetwork;
    },

    socialNetworkLoaded: state => {
        return state.socialNetworkLoaded;
    }
};

const mutations = {
    socialNetworksListReceivedSuccess: (state, response) => {
        state.socialNetworks = response;
    },

    socialNetworkReceivedSuccess: (state, response) => {
        state.socialNetworkLoaded = true;
        state.socialNetwork = response;
    },
};

const actions = {
    loadSocialNetworks({ commit }) {
        return new Promise((resolve, reject) => {
            getSocialNetworks(1,1)
                .then(({data}) => {
                    commit("socialNetworksListReceivedSuccess", data);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    async loadSocialNetwork({ commit }, slug = 'instagram') {
        return new Promise((resolve, reject) => {
            showSocialNetwork(slug)
                .then(({data}) => {
                    commit("socialNetworkReceivedSuccess", data);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
